import type { ResultEvent } from '../../types/events';
import type { BaseThemeColors } from '@fastnorth/kraken/theme/provider';
import type { Photo } from '../../graphql/rest-link/types';
import { ResultType, VirtualChallengeType } from '@fastnorth/timer-api';

export type AppState = {
  event?: ResultEvent;
  hasRacesWithPredictiveTracking?: boolean;
  hasUnsearchableResults?: boolean;
  brandingColors?: BaseThemeColors;
  samplePhotos?: Photo[];
  lastSelectedRace?: string;
  participantSearchSheetState: boolean;
};

export type AppStateAction =
  | { type: 'setEvent'; payload: ResultEvent }
  | { type: 'setBrandingColors'; payload: BaseThemeColors }
  | { type: 'setSamplePhotos'; payload: Photo[] }
  | { type: 'setLastSelectedRace'; payload: string | undefined }
  | { type: 'setSearchSheetState'; payload: boolean };

// NOTE: this reducer is used to store state for the entire application. These are things like
// the current event, user and any other values that are needed throughout the application.
const appReducer = (state: AppState, action: AppStateAction): AppState => {
  switch (action.type) {
    case 'setEvent':
      return {
        ...state,
        event: { ...action.payload },
        hasRacesWithPredictiveTracking:
          action.payload.subEvents?.some(
            (subEvent) =>
              subEvent.settings?.isPredictiveTrackingEnabled ||
              subEvent.challengeSettings?.type === VirtualChallengeType.DISTANCE
          ) ?? false,
        hasUnsearchableResults:
          action.payload.subEvents?.some(
            (subEvent) => subEvent.resultsType === ResultType.UNSTRUCTURED
          ) ?? false,
        participantSearchSheetState: false,
      };
    case 'setBrandingColors':
      return {
        ...state,
        brandingColors: { ...action.payload },
      };
    case 'setSamplePhotos':
      return {
        ...state,
        samplePhotos: action.payload,
      };
    case 'setLastSelectedRace':
      return {
        ...state,
        lastSelectedRace: action.payload,
      };
    case 'setSearchSheetState':
      return {
        ...state,
        participantSearchSheetState: action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
